module.exports = __webpack_public_path__ + "static/media/gallery_03.775360ba.jpg";